import { METRIC_NAMES } from '@config/Consts';
import { RESOURCES as REPORTING_RESOURCES } from '@core/clients/ReportingClient';
import { RESOURCES as AGENT_MANAGER_RESOURCES } from '@core/clients/AgentManagerClient';
import CSATModel from '@core/models/CSATModel';
import AgentViewModel from '@core/models/AgentViewModel';
import BotManagerMetricsModel from '@core/models/BotManagerMetricsModel';
import BotManagerHistoricalModel from '@core/models/BotManagerHistoricalModel';


const BOT_LIST_RESOURCES = {
  MESSAGING_CSAT_DISTRIBUTIONS: REPORTING_RESOURCES.MESSAGING_CSAT_DISTRIBUTIONS,
  AGENT_VIEW: AGENT_MANAGER_RESOURCES.AGENT_VIEW,
  METRICS: AGENT_MANAGER_RESOURCES.METRICS,
  HISTORICAL: AGENT_MANAGER_RESOURCES.HISTORICAL,
};

// model constructors
const RESOURCES_MODEL_MAP = {
  [AGENT_MANAGER_RESOURCES.AGENT_VIEW]: AgentViewModel,
  [REPORTING_RESOURCES.MESSAGING_CSAT_DISTRIBUTIONS]: CSATModel,
  [AGENT_MANAGER_RESOURCES.METRICS]: BotManagerMetricsModel,
  [AGENT_MANAGER_RESOURCES.HISTORICAL]: BotManagerHistoricalModel,
};

//
const RESOURCES_METRICS_MAP = {
  [AGENT_MANAGER_RESOURCES.AGENT_VIEW]: [
    METRIC_NAMES.AGENT_VIEW_AGENT_PICTURE,
    METRIC_NAMES.AGENT_VIEW_AGENT_STATUS,
    METRIC_NAMES.AGENT_VIEW_STATUS_REASON,
    METRIC_NAMES.AGENT_VIEW_AGENT_NAME,
    METRIC_NAMES.AGENT_VIEW_AGENT_SKILLS,
    METRIC_NAMES.AGENT_VIEW_ASSIGNED_CONVERSATIONS,
    METRIC_NAMES.AGENT_VIEW_CONCLUDED_CONVERSATIONS,
    METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE,
    METRIC_NAMES.AGENT_VIEW_CLOSED_RATE,
    METRIC_NAMES.AGENT_VIEW_AGENT_GROUP,
    METRIC_NAMES.AGENT_VIEW_PENDING_RATE,
    METRIC_NAMES.AGENT_VIEW_INTENTS_MATCHED_RATE,
  ],
  [REPORTING_RESOURCES.MESSAGING_CSAT_DISTRIBUTIONS]: [
    METRIC_NAMES.CSAT,
  ],
  [AGENT_MANAGER_RESOURCES.METRICS]: [
    METRIC_NAMES.AGENT_VIEW_METRICS_ONLINE_AGENTS,
    METRIC_NAMES.AGENT_VIEW_METRICS_AWAY_AGENTS,
    METRIC_NAMES.AGENT_VIEW_METRICS_BACK_SOON_AGENTS,
  ],
  [AGENT_MANAGER_RESOURCES.HISTORICAL]: [
    METRIC_NAMES.HISTORICAL_CLOSED_CONVERSATIONS,
    METRIC_NAMES.HISTORICAL_CONCLUDED_CONVERSATIONS,
    METRIC_NAMES.HISTORICAL_TRANSFERS,
  ],
};

export {
  BOT_LIST_RESOURCES,
  RESOURCES_MODEL_MAP,
  RESOURCES_METRICS_MAP,
};
